import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AppLayout } from './components/AppLayout';
import {
    LegacyGalleryDetailRedirect,
    LegacyMemberAreaSectionRedirect,
    LegacyMemberDetailRedirect,
    LegacyNewsDetailRedirect,
    LegacyProjectDetailRedirect,
} from './components/LegacyRedirects';
import { ScrollToTop } from './components/ScrollToTop';
import { GuestOnlyRoute } from './components/GuestOnlyRoute';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import { DashboardPage } from './pages/DashboardPage';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { ChangePasswordPage } from './pages/ChangePasswordPage';
import { ProfilePage } from './pages/ProfilePage';
import { FinancialStatementsPage } from './pages/FinancialStatementsPage';
import { HistoryPage } from './pages/HistoryPage';
import { ImprintPage } from './pages/ImprintPage';
import { ManagementBoardPage } from './pages/ManagementBoardPage';
import { PastPresidentsPage } from './pages/PastPresidentsPage';
import { DuayenUyeler60Page } from './pages/DuayenUyeler60Page';
import { SeniorFivePresidentsPage } from './pages/SeniorFivePresidentsPage';
import { WhatIsRotaryPage } from './pages/WhatIsRotaryPage';
import { RotaryWorldwidePage } from './pages/RotaryWorldwidePage';
import { RotaryTurkeyPage } from './pages/RotaryTurkeyPage';
import { NewsListPage } from './pages/NewsListPage';
import { NewsDetailPage } from './pages/NewsDetailPage';
import { ProjectsListPage } from './pages/ProjectsListPage';
import { ProjectDetailPage } from './pages/ProjectDetailPage';
import { IstanbulRotaractPage } from './pages/IstanbulRotaractPage';
import { InteractClubsPage } from './pages/InteractClubsPage';
import { ToplantilarPage } from './pages/ToplantilarPage';
import { IletisimPage } from './pages/IletisimPage';
import { BulletinsPage } from './pages/BulletinsPage';
import { MemberSectionPage } from './pages/MemberSectionPage';
import { MembersPage } from './pages/MembersPage';
import { MemberDetailPage } from './pages/MemberDetailPage';
import { EventCalendarPage } from './pages/EventCalendarPage';
import { GalleriesPage } from './pages/GalleriesPage';
import { GalleryDetailPage } from './pages/GalleryDetailPage';
import { OcakbasiGruplariPage } from './pages/OcakbasiGruplariPage';
import { PeaceEssayCompetitionPage } from './pages/PeaceEssayCompetitionPage';

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <AuthProvider>
                <Routes>
                    <Route element={<AppLayout />}>
                        <Route index element={<HomePage />} />
                        <Route
                            path="management-board"
                            element={<ManagementBoardPage />}
                        />
                        <Route
                            path="past-presidents"
                            element={<PastPresidentsPage />}
                        />
                        <Route
                            path="60-year-honorary-members"
                            element={<DuayenUyeler60Page />}
                        />
                        <Route
                            path="senior-five-presidents"
                            element={<SeniorFivePresidentsPage />}
                        />
                        <Route path="imprint" element={<ImprintPage />} />
                        <Route path="history" element={<HistoryPage />} />
                        <Route
                            path="financial-statements"
                            element={<FinancialStatementsPage />}
                        />
                        <Route
                            path="news/:newsId"
                            element={<NewsDetailPage />}
                        />
                        <Route path="news" element={<NewsListPage />} />
                        <Route
                            path="projects/:projectId"
                            element={<ProjectDetailPage />}
                        />
                        <Route path="projects" element={<ProjectsListPage />} />
                        <Route
                            path="istanbul-rotaract"
                            element={<IstanbulRotaractPage />}
                        />
                        <Route
                            path="interact-clubs"
                            element={<InteractClubsPage />}
                        />
                        <Route path="our-club" element={<HomePage />} />
                        <Route
                            path="what-is-rotary"
                            element={<WhatIsRotaryPage />}
                        />
                        <Route
                            path="rotary-worldwide"
                            element={<RotaryWorldwidePage />}
                        />
                        <Route
                            path="rotary-in-turkey"
                            element={<RotaryTurkeyPage />}
                        />
                        <Route path="about-rotary" element={<HomePage />} />
                        <Route path="our-services" element={<HomePage />} />
                        <Route
                            path="meetings"
                            element={<ToplantilarPage />}
                        />
                        <Route path="contact" element={<IletisimPage />} />
                        <Route
                            path="3rd-essay-competition-on-international-peace"
                            element={<PeaceEssayCompetitionPage />}
                        />
                        <Route
                            path="login"
                            element={
                                <GuestOnlyRoute>
                                    <LoginPage />
                                </GuestOnlyRoute>
                            }
                        />
                        <Route
                            path="change-password"
                            element={
                                <ProtectedRoute>
                                    <ChangePasswordPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="profile"
                            element={
                                <ProtectedRoute>
                                    <ProfilePage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="panel"
                            element={
                                <ProtectedRoute>
                                    <DashboardPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="member-area/bulletins"
                            element={
                                <ProtectedRoute>
                                    <BulletinsPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="member-area/members/:memberId"
                            element={
                                <ProtectedRoute>
                                    <MemberDetailPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="member-area/members"
                            element={
                                <ProtectedRoute>
                                    <MembersPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="member-area/event-calendar"
                            element={
                                <ProtectedRoute>
                                    <EventCalendarPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="member-area/galleries"
                            element={
                                <ProtectedRoute>
                                    <GalleriesPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="member-area/galleries/:gallerySlug"
                            element={
                                <ProtectedRoute>
                                    <GalleryDetailPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="member-area/fellowship-groups"
                            element={
                                <ProtectedRoute>
                                    <OcakbasiGruplariPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="member-area/:section"
                            element={
                                <ProtectedRoute>
                                    <MemberSectionPage />
                                </ProtectedRoute>
                            }
                        />

                        {/* Legacy Turkish URLs → English */}
                        <Route
                            path="yonetim-kurulu"
                            element={
                                <Navigate to="/management-board" replace />
                            }
                        />
                        <Route
                            path="60-yil-duayen-uyeler"
                            element={
                                <Navigate to="/60-year-honorary-members" replace />
                            }
                        />
                        <Route
                            path="haberler"
                            element={<Navigate to="/news" replace />}
                        />
                        <Route
                            path="haberler/:newsId"
                            element={<LegacyNewsDetailRedirect />}
                        />
                        <Route
                            path="projeler"
                            element={<Navigate to="/projects" replace />}
                        />
                        <Route
                            path="projeler/:projectId"
                            element={<LegacyProjectDetailRedirect />}
                        />
                        <Route
                            path="kulubumuz"
                            element={<Navigate to="/our-club" replace />}
                        />
                        <Route
                            path="rotary-hakkinda"
                            element={<Navigate to="/about-rotary" replace />}
                        />
                        <Route
                            path="hizmetlerimiz"
                            element={<Navigate to="/our-services" replace />}
                        />
                        <Route
                            path="toplantilar"
                            element={<Navigate to="/meetings" replace />}
                        />
                        <Route
                            path="iletisim"
                            element={<Navigate to="/contact" replace />}
                        />
                        <Route
                            path="giris"
                            element={<Navigate to="/login" replace />}
                        />
                        <Route
                            path="uye-alani/bultenler"
                            element={
                                <Navigate to="/member-area/bulletins" replace />
                            }
                        />
                        <Route
                            path="uye-alani/uyeler/:memberId"
                            element={<LegacyMemberDetailRedirect />}
                        />
                        <Route
                            path="uye-alani/uyeler"
                            element={
                                <Navigate to="/member-area/members" replace />
                            }
                        />
                        <Route
                            path="uye-alani/etkinlik-takvimi"
                            element={
                                <Navigate
                                    to="/member-area/event-calendar"
                                    replace
                                />
                            }
                        />
                        <Route
                            path="uye-alani/galeriler/:gallerySlug"
                            element={<LegacyGalleryDetailRedirect />}
                        />
                        <Route
                            path="uye-alani/galeriler"
                            element={
                                <Navigate to="/member-area/galleries" replace />
                            }
                        />
                        <Route
                            path="uye-alani/ocakbasi-gruplari"
                            element={
                                <Navigate
                                    to="/member-area/fellowship-groups"
                                    replace
                                />
                            }
                        />
                        <Route
                            path="uye-alani/:section"
                            element={<LegacyMemberAreaSectionRedirect />}
                        />

                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Route>
                </Routes>
                <ToastContainer
                    position="top-right"
                    autoClose={2800}
                    closeOnClick
                    pauseOnHover
                    draggable
                    theme="light"
                    newestOnTop
                    limit={4}
                />
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
